import React from "react";
import { motion } from "framer-motion";
import { 
  FaLock, 
  FaShieldAlt, 
  FaUserShield, 
  FaInfoCircle, 
  FaEnvelope,
  FaSignOutAlt,
  FaExchangeAlt
} from "react-icons/fa";
import BackButton from "./BackButton";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container dark-theme">
      <nav className="privacy-nav">
        <BackButton />
      </nav>

      <motion.div 
        className="privacy-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <FaLock className="header-icon" />
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-subtitle">Last Updated: {new Date().toLocaleDateString()}</p>
      </motion.div>

      <motion.div
        className="privacy-intro"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 1 }}
      >
        <p>
          This Privacy Policy applies to the <span className="highlight">AUBattle</span> application 
          (hereinafter referred to as "the Application"). By using this service, 
          you agree to the terms outlined herein.
        </p>
      </motion.div>

      <div className="privacy-sections">
        <motion.div 
          className="privacy-card"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="card-header">
            <FaInfoCircle className="card-icon" />
            <h2>Information Collection and Use</h2>
          </div>
          <div className="card-content">
            <p>The Application collects information when you download and use it. This may include:</p>
            <ul className="privacy-list">
              <li>Your device's Internet Protocol (IP) address</li>
              <li>The pages you visit within the Application</li>
              <li>Date, time, and duration of your activity</li>
              <li>Total time spent using the Application</li>
              <li>Your device's operating system</li>
            </ul>
            <p className="note">
              Note: The Application does not collect precise location data but may gather approximate location information for better service.
            </p>
          </div>
        </motion.div>

        <motion.div 
          className="privacy-card"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <div className="card-header">
            <FaUserShield className="card-icon" />
            <h2>Third-Party Access</h2>
          </div>
          <div className="card-content">
            <p>The Application may share anonymized data with third-party service providers:</p>
            <ul className="third-party-list">
              <li><span>Google Play Services</span></li>
              <li><span>AdMob</span></li>
              <li><span>Google Analytics for Firebase</span></li>
              <li><span>Firebase Crashlytics</span></li>
              <li><span>Unity</span></li>
            </ul>
          </div>
        </motion.div>

        <motion.div 
          className="privacy-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <div className="card-header">
            <FaSignOutAlt className="card-icon" />
            <h2>Opt-Out Rights</h2>
          </div>
          <div className="card-content">
            <p>You can stop all data collection by uninstalling the Application.</p>
          </div>
        </motion.div>

        <motion.div 
          className="privacy-card"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <div className="card-header">
            <FaShieldAlt className="card-icon" />
            <h2>Security</h2>
          </div>
          <div className="card-content">
            <p>We implement multiple safeguards to protect your data:</p>
            <ul className="security-list">
              <li>Physical security measures</li>
              <li>Electronic protections</li>
              <li>Procedural safeguards</li>
            </ul>
          </div>
        </motion.div>

        <motion.div 
          className="privacy-card"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <div className="card-header">
            <FaExchangeAlt className="card-icon" />
            <h2>Refund Policy</h2>
          </div>
          <div className="card-content">
            <ul className="refund-list">
              <li>
                <span className="refund-case">If eliminated by a hacker/cheater:</span>
                <span className="refund-action">Full refund to wallet</span>
              </li>
              <li>
                <span className="refund-case">If match is canceled (server issue):</span>
                <span className="refund-action">Full refund to wallet</span>
              </li>
              <li>
                <span className="refund-case">If you miss match start time:</span>
                <span className="refund-action">No refund</span>
              </li>
            </ul>
          </div>
        </motion.div>
      </div>

      <motion.div 
        className="privacy-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 1 }}
      >
        <div className="contact-card">
          <FaEnvelope className="contact-icon" />
          <p>For privacy-related questions, contact us at <span className="contact-email">support@aubattle.com</span></p>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicy;